import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { deletePpsiNir } from '../actions';

const useDeletePpsiNir = () => {
  const dispatch = useDispatch();
  const onDeletePpsiNir = useCallback(
    (ids, formulaCodes) => {
      dispatch(deletePpsiNir(ids, formulaCodes));
    },
    [dispatch]
  );

  return [onDeletePpsiNir];
};

export default useDeletePpsiNir;
